var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_vm._v("Decrypting")]):(_vm.encrypted !== null && _vm.encrypted !== '')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }